
// Use this by default, but probably should be something else
import pages from '../data/associations/production';

export const useNewLayout = ['/', '/good-coverage/']

Object.entries(pages).forEach(([page]) => {
  useNewLayout.push(`/${page}/`)
})
